import React from 'react'
import CounsellorsSidebar from './CounsellorsSidebar'
import H2 from "@material-tailwind/react/Heading2";
import './CounsellorsCSS/CounsellorsHome.css'

const CounsellorsHome = () => {
    return (
        <div className='counsellorsHome'>
            <div className="counsNav">
                <CounsellorsSidebar/>
            </div>  
            <div className="counsellorsHomeRight">
                <div className="counsellorsHomeRightSubDiv">
                    <div className="counsellorsHomeRightSubDivLeft">
                        <H2 id='reqSessionRightLeftHead'>THANK YOU</H2>
                        <p>Medicines cure diseases but only doctors can cure patients. All doctors treat, but a good doctor lets nature heal.</p>
                    </div>

                    <div className="counsellorsHomeRightSubDivRight">
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CounsellorsHome
